import React, { useEffect, useState } from 'react';
import { ProfilePhotoEditProps } from './types';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useProfileEditMutation } from '../../api/profile-edit-api';
import { CACHE_KEY_PROFILE_PHOTO_EDIT } from '../../config/api-constants';
import { ModalEditPhotoProfile } from './modal-edit-photo-profile/modal-edit-photo-profile';
import { Typography } from '@shared/ui/typography/typography';
import { AvatarHover, ToolTipText } from './profile-photo-edit.styles';
import { IconCamera } from '@shared/icon/icon-camera/icon-camera';
import { useLazyCurrentUserQuery } from '@entities/current-user/api/credentials-user-api';

export const ProfilePhotoEdit: React.FC<ProfilePhotoEditProps> = ({ isEditMode = false }) => {
    const [getCurrentUser] = useLazyCurrentUserQuery();
    const [, editProfilePhotoResult] = useProfileEditMutation({ fixedCacheKey: CACHE_KEY_PROFILE_PHOTO_EDIT });
    const [isShowModal, setIsShowModal] = useState(false);

    const handleSuccess = () => {
        getCurrentUser(undefined, false);
    };

    const handleClose = () => {
        setIsShowModal(false);
    };

    const handleOpenModal = () => {
        setIsShowModal(true);
    };

    useEffect(() => {
        if (isShowModal && editProfilePhotoResult.isSuccess) {
            handleSuccess();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={'Фотография профиля успешно изменена'}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            editProfilePhotoResult.reset();
        } else if (isShowModal && editProfilePhotoResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось изменить фотографию профиля.\n${getQueryError(editProfilePhotoResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            editProfilePhotoResult.reset();
        }
    }, [isShowModal, editProfilePhotoResult.isSuccess, editProfilePhotoResult.isError]);

    return (
        <>
            <AvatarHover $isEditMode={isEditMode} onClick={isEditMode ? handleOpenModal : () => {}}>
                {isEditMode && <IconCamera />}
                <ToolTipText>
                    <Typography as='p' align='center' size='body2_short'>
                        Изменить фотографию
                    </Typography>
                </ToolTipText>
            </AvatarHover>
            <ModalEditPhotoProfile isShow={isShowModal} onAccept={handleClose} onClose={handleClose} />
        </>
    );
};
